<template>
  <div class="main col-sm-12">
    <card class="col-sm-8">
      <div slot="header" class='toolsBar'>
        <div class="leftTools">
          <fg-input style="width:150px;">
            <el-date-picker v-model="searchForm.startDt" type="date" placeholder="選擇日期" />
          </fg-input>
          <label style='line-height:30px;'>~</label>
          <fg-input style="width:150px;">
            <el-date-picker v-model="searchForm.endDt" type="date" placeholder="選擇日期" />
          </fg-input>
          <div>
            <l-button type="default" @click="doSearch()">搜尋</l-button>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column prop="name" label="頁面名稱" />
            <el-table-column prop="stuffId" :formatter="getStuffText" label="頁面素材" />
            <el-table-column label="方案">
              <div class="td-actions" slot-scope="props" >
                <template v-for='planId in props.row.planIds'>
                  <div v-bind:key="planId">{{getPlanText(planId)}}</div>
                </template>
              </div>
            </el-table-column>
            <!-- <el-table-column prop="status" 
                            
                            label="備註">
            </el-table-column> -->
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
      <el-dialog
        center
        class="col-12"
        :title="getTitle()"
        :visible.sync="modals.custom">
        <div class='main'>
          <div class='col-sm-8'>
            <fg-input label="頁面名稱"
                    type="text"
                    name="name"
                    class='row'
                    labelClasses="col-md-3 col-12 my-auto"
                    inputClasses="col-md-9 col-12"
                    data-vv-as="頁面名稱"
                    v-model="form.name"
                    v-validate="'required'"    
                    :error="getError('name')"
                    required />
            <div class="form-group align-left row">
              <label class='col-md-3 col-12 my-auto'>顯示商店 *</label>
              <div class='col-md-9 col-12 row main'>
                <el-select class="select-default" data-vv-as="顯示商店" placeholder="請選擇" name="branchId" v-model="form.branchId" :error="getError('branchId')"  v-validate="'required'" >
                    <el-option v-for="i in branches" class="select-default" :value="i.id" :label="i.store.name + ':' + i.name" :key="i.id" />
                </el-select>
              </div>
              <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('branchId')">{{ errors.first('branchId') }}</div>
            </div>
            <fg-input label="Page Alias"
                      type="text"
                      name="alias"
                      class='row'
                      labelClasses="col-md-3 col-12 my-auto"
                      inputClasses="col-md-9 col-12"
                      data-vv-as="Page Alias"
                      v-model="form.alias"
                      v-validate="'required'"    
                      :error="getError('alias')"
                      required />
            <div class="form-group align-left row">
              <label class='col-md-3 col-12 my-auto'>幣別 *</label>
              <div class='col-md-9 col-12 row main'>
                <el-select class="select-default" data-vv-as="幣別" placeholder="請選擇" name="currencyId" v-model="form.currencyId" :error="getError('currencyId')"  v-validate="'required'" >
                    <el-option v-for="i in currencies" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
                </el-select>
              </div>
              <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('currencyId')">{{ errors.first('currencyId') }}</div>
            </div>
            <fg-input label="原價"
                      type="number"
                      name="price"
                      class='row'
                      labelClasses="col-md-3 col-12 my-auto"
                      inputClasses="col-md-9 col-12"
                      data-vv-as="原價"
                      v-model="form.price"   
                      :error="getError('price')" />
            <fg-input label="售價"
                      type="number"
                      name="discount"
                      class='row'
                      labelClasses="col-md-3 col-12 my-auto"
                      inputClasses="col-md-9 col-12"
                      data-vv-as="原價"
                      v-model="form.discount"  
                      :error="getError('discount')" />
            <fg-input label="頁面描述"
                      type="text"
                      name="description"
                      class='row'
                      labelClasses="col-md-3 col-12 my-auto"
                      inputClasses="col-md-9 col-12"
                      data-vv-as="頁面描述"
                      v-model="form.metaDescription"        
                      :error="getError('description')" />
            <fg-input label="頁面關鍵字"
                      type="text"
                      name="keywords"
                      class='row'
                      labelClasses="col-md-3 col-12 my-auto"
                      inputClasses="col-md-9 col-12"
                      data-vv-as="頁面關鍵字"
                      v-model="form.metaKeywords"
                      :error="getError('keywords')" />
          </div>
          <div class='col-sm-4'>
            <div class="align-right">
              <input type='file' @change="imgUpload" />
              <img src="static/img/default-image.jpg" v-show="(form.picUrl == null || form.picUrl =='')" width='200px' />
              <img v-bind:src="form.picUrl" v-show="form.picUrl !==''" width='200px' />
            </div>
          </div>
        </div>
        <div class='col-sm-12'>
          <div class="form-group align-left row">
            <label class='col-md-2 col-12 my-auto'>頁面模式 *</label>
            <div class='col-md-10 col-12 row'>
              <l-checkbox class="my-auto col-md-3" name="webtype" v-model="form.isOnePage" v-validate="'checkWebType'">一頁式</l-checkbox>
              <l-checkbox class="my-auto col-md-3" name="webtype" v-model="form.isOfficial" v-validate="'checkWebType'">官網</l-checkbox>
            </div>
            <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('webtype')">{{ errors.first('webtype') }}</div>
          </div>
          <div class="form-group align-left row">
            <label class='col-md-2 col-12 my-auto'>付款方式 *</label>
            <div class='col-md-10 col-12 row'>
              <l-checkbox class="my-auto col-md-3" name="payment" v-model="payments" :value=1 v-validate="'required'">貨到付款</l-checkbox>
              <l-checkbox class="my-auto col-md-3" name="payment" v-model="payments" :value=2 >信用卡付款(台幣)</l-checkbox>
            </div>
            <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('payment')">{{ '至少選擇一種付款方式' }}</div>
          </div>
          <div class="form-group align-left row">
            <label class='col-md-2 col-12 my-auto'>素材 *</label>
            <div class='col-md-10 col-12 row main'>
              <el-select class="select-default" data-vv-as="素材" placeholder="請選擇" name="stuffId" v-model="form.stuffId" :error="getError('stuffId')"  v-validate="'required'" >
                  <el-option v-for="i in stuff" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
              </el-select>
            </div>
            <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('stuffId')">{{ errors.first('stuffId') }}</div>
          </div>
          <div class="form-group align-left row">
            <label class='col-md-2 col-12 my-auto'>銷售方案 *</label>
            <div class='col-md-10 col-12 row main'>
              <el-select class="select-default" data-vv-as="銷售方案" placeholder="請選擇" name="planIds" v-model="form.planIds" :error="getError('planIds')"  v-validate="'required'" multiple  >
                <el-option v-for="i in plans.filter(plan => plan.extraPlan == 0)" class="select-default" :value="i.id" :label="i.name" :key="i.id" />
              </el-select>
            </div>
            <div class='text-danger invalid-feedback' style="display:block" v-show="errors.has('planIds')">{{ errors.first('planIds') }}</div>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
        </div>
      </el-dialog>
    </card>
    <div class='col-sm-4'>
      <div class='rightBtn'>
        <l-button type="primary"  @click="handlenew()" class='text-right'>新增頁面</l-button>
        <l-button type="primary"  @click="handleNewPlan()" class='text-right'>新增方案</l-button>
        <l-button type="primary"  @click="handleNewStuff()" class='text-right'>新增素材</l-button>
      </div>
      <Stuff ref='stuff' :saleGroup="saleGroupInternal" v-model="stuff" />
      <Plan ref='plan' :saleGroup="saleGroupInternal" v-model="plans" />
    </div>
  </div>
</template>


<script>
 /* eslint-disable */
  import { DatePicker, Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import LSwitch from 'src/components/Switch.vue'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import StuffList from '../../components/StuffList'
  import PlanList from '../../components/PlanList'
  import lib from '../../../lib'
  import tools from '../../../tools'

  export default {
    props: ['saleGroup'],
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      [DatePicker.name]: DatePicker,
      LPagination,
      LSwitch,
      Stuff: StuffList,
      Plan: PlanList
    },
    data() {
      return {
        saleGroupInternal: this.saleGroup,

        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        form: {
          id: '',
          name: '',
          branchId: '',
          currencyId: null,
          stuffId: null,
          alias: '',
          isOnePage: false,
          isOfficial: false,
          metaDescription: '',
          metaKeywords: '',
          planIds:[],
          picUrl: '',
          price: null,
          discount: null,
        },
        searchForm: {
          startDt: null,
          endDt: null,
        },
        query: {
          start_date: null,
          end_date: null,
        },
        image: {
          file: null
        },
        stuff:[],
        plans:[],
        branches: [],
        currencies: [],
        payments:[],
        modals: {
          custom: false
        },
        tableData: []
      }
    },
    async mounted() {
      if (!this.saleGroup) {
        await this.reloadSaleGroup()

        this.$refs.stuff.getData()
        this.$refs.plan.getData()
      }
      await this.getCurrencies()
      await this.getBranches()
      this.$parent.$parent.setSubName(this.saleGroupInternal.name)
      await this.getData()
    },
    created() {
      var _this = this

      
      this.$validator.extend('checkWebType', {
          getMessage: '至少選擇一種',
          validate: (value) => {
            return true
            // return (_this.form.isOnePage || _this.form.isOfficial) 
          }
      });
    },
    destroyed() {
      this.$parent.$parent.setSubName('');
    },
    watch: {
      'pagination.currentPage': async function(val) {
      }
    },
    computed: {

    },
    methods: {
      reloadSaleGroup: async function() {
        var data = await lib.getSaleGroup(this.$route.params.id)
        if (data.status == 0) {
          var result = data.result
          this.saleGroupInternal = result.saleGroup
        }
      },

      getStatusText(row, idx) {
        return (row.status)?'啟用':'停用'
      },
      getUserGroupsName(row, idx) {

      },
      getStuffText(row, idx) {
        var stuffId = row.stuffId
        for (var i=0 ; i < this.stuff.length ; i++) {
          if (this.stuff[i]['id'] == stuffId) {
            return this.stuff[i]['name']
          }
        }
        return ''
      },
      getPlanText(id) {
        for (var i=0 ; i < this.plans.length ; i++) {
          if (this.plans[i]['id'] == id) {
            return this.plans[i]['name']
          }
        }
        return ''
      },  
      getTitle() {
        return (this.form.id == '')?'新增銷售頁面':'編輯銷售頁面'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return
          _this.createAndUpdate()
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      handleNewStuff() {
        this.$refs.stuff.handlenew()
      },
      handleNewPlan() {
        this.$refs.plan.handlenew()
      },
      imgUpload(event) {
        var _this = this
        const file = event.target.files.item(0);
        const reader = new FileReader();
        reader.addEventListener("load", function() {
          _this.form.picUrl = reader.result;
          _this.image.file = file
          event.target.value = ''
        }, false);
        reader.readAsDataURL(file);
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id;
        this.form.name = row.name;
        this.form.branchId = row.branchId;
        this.form.currencyId = row.currencyId;
        this.form.stuffId = row.stuffId;

        this.form.alias = row.alias;
        this.form.isOnePage = row.isOnePage;
        this.form.isOfficial = row.isOfficial;
        this.form.metaDescription = row.metaDescription;
        this.form.metaKeywords = row.metaKeywords;
        let payments = (row.payments).toString(2).split('').reverse().map((value, idx) => (Math.pow(2, idx) * value));
        this.payments = payments;
        this.form.planIds = row.planIds;
        this.form.picUrl = row.picUrl;
        this.form.price = row.price;
        this.form.discount = row.discount;
        this.openModal('custom');
      },
      doSearch() {
        this.pagination.currentPage = 1
        this.query.start_date = this.searchForm.startDt
        this.query.end_date = this.searchForm.endDt
        this.getData()
      },
      async getCurrencies() {
        var data = await lib.getCurrencyList({ limit: 50, offset: 0})
        if (data.status == 0) {
          var result = data.result
          this.currencies = result.currencies
        }
      },
      async getBranches() {
        var data = await lib.getBranchList({ limit: 50, offset: 0})
        if (data.status == 0) {
          var result = data.result
          this.branches = result.branches
        }
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getSalePageList(this.saleGroupInternal.id, this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.salePages
        }

        var qdata = {}
        qdata.offset = 0
        qdata.limit = 99
        data = await lib.getCurrencyList(qdata)
        if (data.status == 0) {
          var result = data.result
          this.currencies = result.currencies
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
            _this.form.id = '';
            _this.form.name = '';
            _this.form.branchId = '';
            _this.form.currencyId = '';
            _this.form.stuffId = '';
            _this.form.alias = '';
            _this.form.isOfficial = '';
            _this.form.metaKeywords = '';
            _this.form.metaDescription = '';
            _this.form.isOnePage = false;
            _this.form.isOfficial = false;
            _this.form.planIds = [];
            _this.form.picUrl = '';
            _this.form.price = null;
            _this.form.discpunt = null;
            _this.payments = [];
            _this.image.file = null;
          resolve()
        })
      },
      async uploadImage() {
        var data = await lib.uploadImage('salepage', this.image.file)
        if (data.status == 0) {
          return data.result.picUrl
        } else {
          return ''
        } 
      },
      async createAndUpdate() {
        if (this.image.file) {
          var image = await this.uploadImage();
          if (image == '') {
            this.$swal('上傳圖片失敗', '', 'error');
            return;
          }  
          this.form.picUrl = image;
          this.image.file = null;
        }
        var actionText = '';
        this.form.payments = this.payments.reduce((total, item) => parseInt(total) + parseInt(item));
        this.form.price = parseInt(this.form.price);
        this.form.discount = parseInt(this.form.discount);
        if (this.form.id === '') {
            var data = await lib.createSalePage(this.saleGroupInternal.id, this.form)
            actionText = '新增'
          } else {
            var data = await lib.updateSalePage(this.saleGroupInternal.id, this.form.id, this.form);
            actionText = '更新'
        }
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal(`已${actionText}`, '', 'success')
        } else if (data.status == 7) {
          this.$swal('Page Alias重複', '', 'error')
        } else {
          this.$swal(`${actionText}失敗`, '', 'error')
        }
      },
      async handleDelete(id, prop) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteItem(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>

.main {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > * {
  padding-right: 10px;
}

.rightBtn {
  display: flex;
  justify-content: space-between;
}

</style>
